import { SET_CONTENT } from "../actions/content.action";

const INITIAL_STATE = {
   content: [],
};

export default function careteamList(state = INITIAL_STATE, action) {
   switch (action.type) {
      case SET_CONTENT:
         return {
            ...state,
            content: action.payload,
         };
      default:
         return state;
   }
}
